/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import { useEffect, useState } from "react";
import useFacebookPixel from "./hooks/useFacebookPixel";
import useGoogleAnalytics from "./hooks/useGoogleAnalytics";
import useGoogleTagManager from "./hooks/useGoogleTagManager";
import useSmartlook from "./hooks/useSmartlook";
import useSnapchatPixel from "./hooks/useSnapchatPixel";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useAtom } from "jotai";
import { analyticsHelpersIds } from "@/hooks/analytics-helpers-ids";
import useTiktokPixel from "./hooks/useTiktokPixel";
import useShouldFire from "./hooks/useShouldFire";

const PageViewPixel = () => {
  const getCompany = useGetCompanyQuery();
  const shouldFire = useShouldFire();
  const [refresh, setRefresh] = useState(false);
  const [, setaAnalyticsHelpersIds] = useAtom(analyticsHelpersIds);
  const { theme } = getCompany?.data?.result! ?? {};
  const {
    smartlook_code,
    snapchat_code,
    facebook_code,
    google_analytics_id,
    google_tag,
    tiktok_code,
  } = theme?.settings! ?? {};
  useFacebookPixel(facebook_code, refresh);
  useSnapchatPixel(snapchat_code, refresh);
  useTiktokPixel(tiktok_code, refresh);
  useSmartlook(smartlook_code, refresh);
  useGoogleAnalytics(google_analytics_id, refresh);
  useGoogleTagManager(google_tag, refresh);
  useEffect(() => {
    if (shouldFire) {
      setaAnalyticsHelpersIds({
        smartlook_code,
        snapchat_code,
        facebook_code,
        google_analytics_id,
        google_tag,
      });
    }
  }, [theme, shouldFire]);
  useEffect(() => {
    if (shouldFire && !refresh) {
      setRefresh(true);
    }
  }, [shouldFire]);
  if (!shouldFire) return;
  return <></>;
};

export default PageViewPixel;
